import { Flex, Form, Select, Space, Typography } from 'antd';

import { SearchButtons } from '@app/components';
import { PREFIX } from '@app/constants';
import { ConfirmSalaryModal } from '@app/pages/Analytics/components';
import { MONTHS, YEARS, DEFAULT_FILTERS_DATA } from '@app/pages/Analytics/data';
import { useReportEffects } from '@app/pages/Analytics/hooks';
import { useSalaryReport } from '@app/pages/Analytics/SalaryReport/hooks';
import { EditCellModal } from '@app/pages/Analytics/SalaryReport/ui/EditCellModal';
import { SalaryReportTable } from '@app/pages/Analytics/SalaryReport/ui/SalaryReportTable';

import '@pages/Analytics/SalaryReport/styles/SalaryReport.desktop.scss';

const { Text } = Typography;
const { Item } = Form;

export const SalaryReport = () => {
  const {
    handleReset,
    form,
    handleSubmitForm,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    selectedEmployeeId,
    onConfirmSalary,
    handleEditableCellClick,
    editCellModalOpen,
    closeEditCellModal,
    editableValue,
    handleEditableValueChange,
    editableField,
    setEditableValue,
    handleSaveEditCellModal,
    isUpdateEmployeeSalaryLoading,
    isLoading,
    tableData,
    fetchData,
    handleSearchData,
    shownPeriod,
    isRevokeConfirm,
    handleRevokeConfirm,
    hasUserRightToConfirmSalary,
    hasUserRightToEditBefore,
    hasUserRightToEditAfterConfirm,
  } = useSalaryReport();
  useReportEffects({
    handleSearchData,
  });

  return (
    <div className={`${PREFIX}salary-report`}>
      <Form
        form={form}
        onFinish={handleSubmitForm}
        initialValues={DEFAULT_FILTERS_DATA}
      >
        <Space
          className="content-header-space"
          direction="vertical"
          size="large"
        >
          <Flex justify="space-between">
            <Space size="large" align="baseline">
              <Text strong>Период:</Text>
              <Item name="filterMonth">
                <Select
                  placeholder="Выбор месяца"
                  popupMatchSelectWidth={false}
                  options={MONTHS}
                  className="filters-select"
                />
              </Item>
              <Item name="filterYear">
                <Select
                  placeholder="Выбор года"
                  popupMatchSelectWidth={false}
                  options={YEARS}
                  className="filters-select"
                />
              </Item>
            </Space>
            <SearchButtons
              className="desktop-buttons"
              resetAll={handleReset}
              showData={form.submit}
            />
          </Flex>
          <SalaryReportTable
            isLoading={isLoading}
            tableData={tableData}
            onConfirm={onConfirmSalary}
            handleEditableCellClick={handleEditableCellClick}
            handleRevokeConfirm={handleRevokeConfirm}
            hasUserRightToConfirmSalary={hasUserRightToConfirmSalary}
            hasUserRightToEditBefore={hasUserRightToEditBefore}
            hasUserRightToEditAfterConfirm={hasUserRightToEditAfterConfirm}
          />
        </Space>
      </Form>
      <ConfirmSalaryModal
        isOpen={isConfirmModalOpen}
        userId={selectedEmployeeId}
        setIsOpen={setIsConfirmModalOpen}
        fetchData={fetchData}
        year={String(shownPeriod.filterYear)}
        month={String(shownPeriod.filterMonth)}
        showComment
        isRevokeConfirm={isRevokeConfirm}
      />
      <EditCellModal
        editCellModalOpen={editCellModalOpen}
        closeEditCellModal={closeEditCellModal}
        editableField={editableField}
        editableValue={editableValue}
        handleEditableValueChange={handleEditableValueChange}
        setEditableValue={setEditableValue}
        handleSaveEditCellModal={handleSaveEditCellModal}
        isLoading={isUpdateEmployeeSalaryLoading}
      />
    </div>
  );
};
